import { useEffect, useState } from 'react';
import BusinessService from '../../services/businessService';

const useBusinesses = () => {
    const [businesses, setBusinesses] = useState([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const SearchBusiness = () => {
            setLoading(true);
            BusinessService
                .GetAll()
                .then(res => setBusinesses(res))
                .finally(() => setLoading(false));
        }

        SearchBusiness();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return {
        businesses,
        loading
    }
}

export default useBusinesses;